import resumeData from "../../data/resumeData";

const ProjectsSection = ({ darkMode = false }) => (
  <section
    id="projects"
    className={`py-14 sm:py-16 ${darkMode ? "bg-stone-900 text-white" : "bg-white text-stone-950"}`}
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
      <p className="text-xs font-black uppercase tracking-[0.24em] text-teal-800 dark:text-teal-300">
        Selected work
      </p>
      <h2 className="mt-3 max-w-3xl text-3xl font-black leading-tight sm:text-4xl">
        Client programmes and outcomes.
      </h2>
      <p className="mt-4 max-w-2xl text-sm leading-7 text-stone-700 dark:text-stone-300">
        Focused on the programmes that best show architecture, security, and delivery depth.
      </p>

      <div className="mt-8 grid gap-4 md:grid-cols-3">
        {resumeData.projects.map((project) => (
          <article
            key={project.name}
            className={`rounded-2xl border p-5 sm:p-6 ${
              darkMode ? "border-stone-700 bg-stone-800/50" : "border-stone-950/10 bg-[#f8f6f1]"
            }`}
          >
            <p className="text-xs font-bold uppercase tracking-wider text-teal-800 dark:text-teal-300">
              {project.category}
            </p>
            <h3 className="mt-3 text-xl font-black">{project.name}</h3>
            <p className="mt-3 text-sm leading-7 text-stone-700 dark:text-stone-300">
              {project.description}
            </p>
            {project.impact && (
              <p
                className={`mt-3 border-l-2 pl-3 text-sm font-semibold leading-6 ${
                  darkMode ? "border-teal-400/50 text-teal-200" : "border-teal-700/40 text-teal-900"
                }`}
              >
                {project.impact}
              </p>
            )}
            <ul className="mt-4 flex flex-wrap gap-2">
              {project.tools.map((tool) => (
                <li
                  key={tool}
                  className="rounded-full border border-stone-500/25 px-2.5 py-1 text-[0.7rem] font-semibold"
                >
                  {tool}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>

      {resumeData.earlierProjects?.length > 0 && (
        <div
          className={`mt-6 rounded-2xl border p-5 ${
            darkMode ? "border-stone-700 bg-stone-950/40" : "border-stone-950/10 bg-[#f4f1ea]"
          }`}
        >
          <p className="text-xs font-black uppercase tracking-[0.2em] text-stone-500">Earlier programmes</p>
          <ul className="mt-3 grid gap-3 sm:grid-cols-2">
            {resumeData.earlierProjects.map((project) => (
              <li key={project.name} className="text-sm leading-6">
                <span className="font-bold">{project.name}</span>
                <span className="text-stone-600 dark:text-stone-400"> — {project.summary}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  </section>
);

export default ProjectsSection;
